import Application from 'ef_sdk';
import routes from 'routes';
import extensions from 'extensions';

if(extensions !== undefined) {
  extensions();
}

module.exports = {
  configure: function(options){
    options = (options || {});
    var appConfig = {
      routes: routes,
      controllerPath: '',
      controllerSuffix: '-controller',
      pushState: false
    };
    options = _.extend(appConfig, options);
    let app = new Application(options);
    window.onerror = () => {
      Chaplin.mediator.publish('application:error', app);
    };
    return app;
  }
};
